import { render, staticRenderFns } from "./App.vue?vue&type=template&id=65ff3c6c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=65ff3c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_1687856227/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports